import React, { useContext, useState, useEffect, useRef } from "react";
import NavBar from "../Components/Main/NavBar";
import Footer from "../Components/Main/Footer";
import { Link, useNavigate } from "react-router-dom";
import { useCheckout } from "../Context/CheckoutContext";
import { AuthContext } from "../Context/AuthProvider";
import { CartContext } from "../Context/CartProvider";
import "../css/Checkout/Checkout.css";
import Option from "../Assets/fizetesilehetosegek.png";

function loadGLSScript() {
  return new Promise((resolve) => {
    // Check if already loaded
    if (window.customElements?.get("gls-dpm")) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.type = "module";
    script.src = "https://map.gls-hungary.com/widget/gls-dpm.js";
    script.onload = () => resolve();
    document.body.appendChild(script);
  });
}

const Checkout = () => {
  const { user } = useContext(AuthContext);
  const { order, setOrder, shipping, setShipping } = useCheckout();
  const { price } = useContext(CartContext);
  const navigate = useNavigate();

  const [cash, setCash] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [accept, setAccept] = useState(false);
  const [shippingMethod, setShippingMethod] = useState("home");
  const [pickupPoint, setPickupPoint] = useState(null);

  const [form, setForm] = useState({
    name: "",
    tax: "",
    company_name: "",
    address: "",
    city: "",
    zip: "",
    email: "",
    phone: "",
    payment: "bankcard",
    plus: 0,
    shipment: shippingMethod
  });

  const [shippingForm, setShippingForm] = useState({
    name: "",
    address: "",
    city: "",
    zip: "",
    phone: "",
  });

  const SHIPPING_COST =
  shippingMethod === "personal"
    ? 0
    : price < 50000
    ? 2159
    : 0;


  const checkHandler = () => setIsChecked(!isChecked);
  const acceptHandler = () => setAccept(!accept);

  // Handle GLS pickup point selection
  
  useEffect(() => {
    if (shippingMethod !== "pickup") return;
  
    let el;
    let handleChange;
  
    const initGLS = async () => {
      await loadGLSScript(); // ensure script is loaded
      el = document.getElementById("gls-map");
  
      if (!el) return;
  
      // Listen to the GLS change event
      handleChange = (e) => {
        const selectedPoint = e.detail;
        if (selectedPoint) {
          setPickupPoint(selectedPoint);
        }
      };
  
      el.addEventListener("change", handleChange);
    };
  
    initGLS();
  
    return () => {
      if (el && handleChange) {
        el.removeEventListener("change", handleChange);
      }
    };
  }, [shippingMethod]);
  

  // Autofill from user
  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        tax: user.vat_number || "",
        company_name: user.company_name || "",
        address: user.address || "",
        city: user.city || "",
        zip: user.postcode || "",
        email: user.email || "",
        phone: user.phone || "",
        payment: "bankcard",
        plus: cash,
      });
    }

    if (price + 1585 + 2159 > 50000) setCash(1585);
    else if (price + 1213 + 2159 > 20000) setCash(1213);
    else if (price + 839 + 2159 > 10000) setCash(839);
    else setCash(726);
  }, [user, price]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!accept) {
      alert("Elfogadom az Általános Szerződési Feltételek-et");
      return;
    }

    if (!form.name || !form.address || !form.city || !form.zip) {
      alert("Töltse ki az összes mezőt");
      return;
    }

    if (shippingMethod === "pickup" && !pickupPoint) {
      alert("Kérjük, válasszon csomagpontot a térképen!");
      return;
    }

    setOrder({
      ...form,
      shippingMethod,
      pickupPoint,
    });
    setShipping(shippingForm);

    navigate("/fizetes/osszegzes");
  };

  return (
    <div>
      <NavBar />
      <div className="checkout-container">
        <div className="checkout-status">
          <Link to="/kosar">Kosár</Link>
          <Link to="/fizetes/szallitas">Szállítás</Link>
          <Link onClick={() => navigate("/fizetes/osszegzes")}>Összegzés</Link>
        </div>

        <div className="checkout-shipping">
          <form onSubmit={handleSubmit}>
            {/* Billing address fields */}
            <input
              type="text"
              placeholder="Név"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Adószám"
              value={form.tax}
              onChange={(e) => setForm({ ...form, tax: e.target.value })}
            />
            <input
              type="text"
              placeholder="Cégnév"
              value={form.company_name}
              onChange={(e) =>
                setForm({ ...form, company_name: e.target.value })
              }
            />
            <input
              type="text"
              placeholder="Cím"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Város"
              value={form.city}
              onChange={(e) => setForm({ ...form, city: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Irányítószám"
              value={form.zip}
              onChange={(e) => setForm({ ...form, zip: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Telefonszám"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              required
            />

            {/* Optional: separate shipping address */}
            <span>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={checkHandler}
              />
              <label>A szállítási cím különbözik</label>
            </span>

            {isChecked && (
              <div className="shipping-address">
                <h3>Szállítási cím:</h3>
                <input
                  type="text"
                  placeholder="Név"
                  onChange={(e) =>
                    setShippingForm({ ...shippingForm, name: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Cím"
                  onChange={(e) =>
                    setShippingForm({ ...shippingForm, address: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Város"
                  onChange={(e) =>
                    setShippingForm({ ...shippingForm, city: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Irányítószám"
                  onChange={(e) =>
                    setShippingForm({ ...shippingForm, zip: e.target.value })
                  }
                />
                <input
                  type="text"
                  placeholder="Telefonszám"
                  onChange={(e) =>
                    setShippingForm({ ...shippingForm, phone: e.target.value })
                  }
                />
              </div>
            )}

            {/* Payment */}
            <span>Fizetési mód:</span>
            <select
              value={form.payment}
              onChange={(e) => setForm({ ...form, payment: e.target.value })}
            >
              <option value="bankcard">Bankkártya</option>
              {cash > 0 && <option value="cash">Készpénz {cash} Ft</option>}
              <option value="banktransfer">Banki átutalás</option>
            </select>
            {form.payment === "bankcard" && (
              <img src={Option} alt="fizetési lehetőségek" />
            )}

            {/* Shipping method */}
            <span>Szállítási mód:</span>
            <select
              value={shippingMethod}
              onChange={(e) => setShippingMethod(e.target.value)}
            >
              <option value="home">
                Házhozszállítás GLS - {SHIPPING_COST} Ft
              </option>
              <option value="pickup">
                Csomagpontra szállítás - {SHIPPING_COST} Ft
              </option>
              <option value="personal">
                'Házhozszállítás(Szombathely)' - Ingyenes
              </option>
            </select>

            {/* GLS Pickup Map */}
            {shippingMethod === "pickup" && (
              <div className="pickup-point-selection">
                <h3>Válassz GLS csomagpontot:</h3>

                <div className="pickup-map-container">
                  <gls-dpm
                    id="gls-map"
                    country="hu"
                    language="hu"
                    filter-type="parcel-shop"
                  ></gls-dpm>
                </div>

                {!pickupPoint && (
                  <p style={{ color: "red", marginTop: "0.5rem" }}>
                    * Kérjük, válassz egy csomagpontot a térképen a továbblépéshez.
                  </p>
                )}

                {pickupPoint && (
                  <div className="pickup-summary">
                    <p>
                      <strong>{pickupPoint.name}</strong> <br />
                      {pickupPoint.contact.address}, {pickupPoint.contact.city}{" "}
                      {pickupPoint.contact.postalCode}
                    </p>
                  </div>
                )}
              </div>
            )}

            {/* Accept Terms */}
            <span>
              <input type="checkbox" checked={accept} onChange={acceptHandler} />
              <label>
                Elfogadom az{" "}
                <a href="/files/aszf.pdf" target="_blank">
                  Általános Szerződési Feltételek
                </a>
                -et
              </label>
            </span>

            <button
              type="submit"
              disabled={
                !accept ||
                (shippingMethod === "pickup" && !pickupPoint)
              }
            >
              Következő
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Checkout;
